<form [formGroup]="formGroup" (submit)="saveChanges()" fxLayout="column" fxLayoutAlign="center center">
 
  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close(false)" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ data?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_RECIPIENT' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_RECIPIENT' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="loading.submit">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>
 
  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- recipient-dropdown -->
    <esc-recipient-dropdown 
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="recipientSelected($event)"
      [previousData]="data"
      [disabled]="isDisabled"
      [groupMntDropdown]="true"
      *ngIf="data.id"
      >
    </esc-recipient-dropdown>
 
    <esc-recipient-multiselect-dropdown 
      class="width-100" 
      [labelFlex]="20"
      [formWrapperFlex]="'auto'" 
      [textLabel]="recipientSelectorLabel" 
      [wrapperLayoutAlign]="'start center'"
      [groupMntDropdown]="true"
      [previousData]="data"
      [disabled]="isDisabled"
      (recipientSelected)="recipientSelected($event)"
      *ngIf="!data.id"
      >
    </esc-recipient-multiselect-dropdown>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>
 
  </div>
</form>